import { z } from 'zod';
import { ChannelTypeSchema } from './channel-type.dto';

export const AssistantSettingsDtoSchema = z.object({
    id: z.string().describe('The id of the assistant setting'),
    purpose: z.string().describe('The purpose (goal) of the playbook'),
    tone: z.string().describe('The tone of the user wants to communicate in'),
    context: z.string().describe('Additional information that is relevant in the context of this playbook'),
    defaultChannel: ChannelTypeSchema.describe('The default channel of the user wants to use when writing messages'),
    targetGroup: z
        .string()
        .describe('A description of the people that are the user wants to target with this playbook'),
});
